import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["fund"]

  connect() {
    this.accountSelects = this.element.querySelectorAll('[data-fund-filterable]')

    // Store original options for each filterable select
    this.accountSelects.forEach(select => {
      select._allOptions = Array.from(select.options)
    })

    this.filterByFund()
  }

  fundChanged() {
    this.filterByFund()
  }

  filterByFund() {
    const fundId = this.hasFundTarget ? this.fundTarget.value : ""

    this.accountSelects.forEach(select => {
      const currentValue = select.value
      const allOptions = select._allOptions || Array.from(select.options)

      // Clear and rebuild options
      select.innerHTML = ""

      allOptions.forEach(option => {
        // Always keep the prompt/blank option
        if (!option.value || option.value === "") {
          select.appendChild(option.cloneNode(true))
          return
        }

        // Show all options if no fund selected, otherwise filter by fund
        if (!fundId || option.getAttribute("data-fund-id") === fundId) {
          select.appendChild(option.cloneNode(true))
        }
      })

      // Restore selection if the option still exists
      if (currentValue) {
        const exists = Array.from(select.options).some(o => o.value === currentValue)
        select.value = exists ? currentValue : ""
      }
    })
  }
}
